import { useEffect } from 'react'

import { useTrackerClient } from '../../TrackerClientProvider.js'

import { ActorAnalyticsContext, TargetAnalyticsContext } from './snowplow.js'

interface UseTrackerProps {
  actor?: Partial<ActorAnalyticsContext>
  target?: Partial<TargetAnalyticsContext>
}

export const useTracker = ({ actor, target }: UseTrackerProps = {}) => {
  const { tracker, unsetTracker } = useTrackerClient()

  useEffect(() => {
    if (!tracker) {
      return null
    }

    tracker.setActor(actor)
    tracker.setTarget(target)

    return () => {
      unsetTracker({ actor, target })
    }
  }, [tracker, actor, target, unsetTracker])

  return tracker
}
